import WeddingDuoLogo from '../images/shared/logo-cobrand-weddingduo.png';

const cobrandingPartnerships = {
  weddingduo: {
    name: 'The Wedding Duo',
    logo: WeddingDuoLogo,
  },
};

export default cobrandingPartnerships;
